import { render } from "./KofiWidget.vue?vue&type=template&id=24b24dfc&scoped=true"
import script from "./KofiWidget.vue?vue&type=script&lang=js"
export * from "./KofiWidget.vue?vue&type=script&lang=js"

import "./KofiWidget.vue?vue&type=style&index=0&id=24b24dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b24dfc"]])

export default __exports__